import { useMemo } from "react";
import { useListReviewsContent, useListReviewsIndexContent } from "@tecnobit-srl/content-types-list-reviews/lazy";
import { useCarouselReviewsContent } from "@tecnobit-srl/content-types-carousel-reviews/lazy";
//#region src/index.ts
var useReviewsContentTypes = () => {
	const listReviews = useListReviewsContent();
	const listReviewsIndex = useListReviewsIndexContent();
	const carouselReviews = useCarouselReviewsContent();
	return useMemo(() => ({
		...listReviews,
		...listReviewsIndex,
		...carouselReviews
	}), [
		listReviews,
		listReviewsIndex,
		carouselReviews
	]);
};
//#endregion
export { useReviewsContentTypes };
